import { render } from "./AutoCompleteLanguage.vue?vue&type=template&id=f905d25e"
import script from "./AutoCompleteLanguage.ts?vue&type=script&lang=js"
export * from "./AutoCompleteLanguage.ts?vue&type=script&lang=js"

import exportComponent from "/Users/r.hutter/Resilio Sync/_Workspace/git/TitleTool-NG/titletool-nextgen-server/titletool-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__